// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hamburger {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.3);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 8px;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  backdrop-filter: blur(5px);
}

.hamburger span {
  width: 100%;
  height: 2px;
  background-color: white;
  transition: all 0.3s ease;
  transform-origin: 1px;
}

.hamburger.open span:first-child {
  transform: rotate(45deg);
}

.hamburger.open span:nth-child(2) {
  opacity: 0;
}

.hamburger.open span:last-child {
  transform: rotate(-45deg);
}

.nav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #000;
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-overlay.open {
  visibility: visible;
  opacity: 1;
}

.nav-content {
  text-align: left;
  padding: 2rem;
  width: 100%;
  max-width: 1200px;
}

.nav-links {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.nav-links a {
  color: white;
  text-decoration: none;
  font-family: 'Josefin Sans', sans-serif;
  font-size: 3rem;
  font-weight: 700;
  transition: color 0.3s ease;
  text-transform: uppercase;
}

.nav-links a:hover {
  color: var(--color-gold);
} `, "",{"version":3,"sources":["webpack://./src/styles/Nav.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".hamburger {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  width: 40px;\n  height: 40px;\n  background: rgba(0, 0, 0, 0.3);\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  padding: 8px;\n  z-index: 1001;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  backdrop-filter: blur(5px);\n}\n\n.hamburger span {\n  width: 100%;\n  height: 2px;\n  background-color: white;\n  transition: all 0.3s ease;\n  transform-origin: 1px;\n}\n\n.hamburger.open span:first-child {\n  transform: rotate(45deg);\n}\n\n.hamburger.open span:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger.open span:last-child {\n  transform: rotate(-45deg);\n}\n\n.nav-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background-color: #000;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.3s ease;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.nav-overlay.open {\n  visibility: visible;\n  opacity: 1;\n}\n\n.nav-content {\n  text-align: left;\n  padding: 2rem;\n  width: 100%;\n  max-width: 1200px;\n}\n\n.nav-links {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.nav-links a {\n  color: white;\n  text-decoration: none;\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 3rem;\n  font-weight: 700;\n  transition: color 0.3s ease;\n  text-transform: uppercase;\n}\n\n.nav-links a:hover {\n  color: var(--color-gold);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
